<button (click)="export()" [disabled]="disabled"
      class="btn btn-gradient-primary">
      {{name | translate}}
      <i style="font-size: 12px;" class="mdi mdi-3px mdi-spin mdi-loading" [hidden]="isLoading"></i>
</button>